import { createContext } from 'react';

export const inputContainerRefContext = createContext<React.RefObject<HTMLElement>>({
  current: null,
});
